import { render, staticRenderFns } from "./baidu.vue?vue&type=template&id=15873d22"
import script from "./baidu.vue?vue&type=script&lang=js"
export * from "./baidu.vue?vue&type=script&lang=js"
import style0 from "./baidu.vue?vue&type=style&index=0&id=15873d22&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15873d22')) {
      api.createRecord('15873d22', component.options)
    } else {
      api.reload('15873d22', component.options)
    }
    module.hot.accept("./baidu.vue?vue&type=template&id=15873d22", function () {
      api.rerender('15873d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/map/baidu.vue"
export default component.exports